/**
 * Actions for Ingress Event Association
 */
export enum ingressServiceEvent {
  SAVE_SERVICE_EVENT = 'SAVE_SERVICE_EVENT',
  CLEAR_SERVICE_EVENT = 'CLEAR_SERVICE_EVENT',
  DELETE_SERVICE_EVENT = 'DELETE_SERVICE_EVENT',
  UPDATE_SERVICE_EVENT = 'UPDATE_SERVICE_EVENT',
  DELETE_OPERATION_ASSOCIATED_MAPPING = 'DELETE_OPERATION_ASSOCIATED_MAPPING'
}
